import { Transform, Type } from 'class-transformer';
import {
	dateTransformer,
	primitive_ClassTransform_Types,
} from 'src/lib/utilities/api/class-transformer-types';

export enum StudentPauseRequestStatus {
	Pending = 'pending',
	Authorized = 'authorized',
	Approved = 'approved',
	Rejected = 'rejected',
	Complete = 'complete',
	Scheduled = 'scheduled',
}

export class PauseExitReasonModel {
	@Type(primitive_ClassTransform_Types.string)
	state_exit_reasons: Map<string, string>;
}

export class StudentPausePauseInfoModel {
	@Transform(dateTransformer)
	on_timestamp: Date;
	by: string;
	by_name: string;
	explanation: string;
}

export class StudentPauseRequestModel {
	exit_code: string;
	reason: string;
	@Transform(dateTransformer)
	start_timestamp: Date;
	@Transform(dateTransformer)
	end_timestamp: Date;
	parent_confirmation: boolean;
	intervention_strategy: string;

	@Transform(dateTransformer)
	pause_started: Date;
	@Transform(dateTransformer)
	pause_ended: Date;

	request_id: number;
	requested_by: number;
	requested_by_name: string;
	@Transform(dateTransformer)
	requested_on: Date;

	last_edited_by: number;
	last_edited_by_name: string;
	@Transform(dateTransformer)
	last_edited_on: Date;

	authorizers: {
		uid: number;
		name: string;
	}[];

	authorized_by: number;
	authorized_by_name: string;
	@Transform(dateTransformer)
	authorized_on: Date;

	approved_by: number;
	approved_by_name: string;
	@Transform(dateTransformer)
	approved_on: Date;

	rejected_by: number;
	rejected_by_name: string;
	@Transform(dateTransformer)
	rejected_on: Date;

	status: StudentPauseRequestStatus;
}

export function StudentPauseRequestModel_ClassTransform_Type() {
	return StudentPauseRequestModel;
}

export function StudentPausePauseInfoModel_ClassTransform_Type() {
	return StudentPausePauseInfoModel;
}
